module.exports = __webpack_public_path__ + "img/8312.8ca2ca5e.jpg";